var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPrior(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 19,
    viewBox: "0 0 20 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.4099 3.77937L13.4269 1.76238L13.4269 1.76238C14.118 1.07133 14.4635 0.725803 14.8523 0.573348C15.3217 0.389288 15.8432 0.389288 16.3126 0.573348C16.7014 0.725803 17.0469 1.07133 17.7379 1.76238C18.429 2.45343 18.7745 2.79896 18.927 3.18773C19.111 3.6571 19.111 4.17867 18.927 4.64804C18.7745 5.03681 18.429 5.38234 17.7379 6.07339L15.7452 8.06618C13.9448 7.03802 12.4516 5.55616 11.4099 3.77937ZM9.95553 5.23379L2.42804 12.7613C2.00298 13.1863 1.79045 13.3989 1.65072 13.66C1.51098 13.9211 1.45204 14.2158 1.33415 14.8052L0.641 18.271C0.574478 18.6036 0.541217 18.7699 0.635825 18.8645C0.730433 18.9591 0.896738 18.9258 1.22935 18.8593L4.69509 18.1662L4.69511 18.1662C5.28455 18.0483 5.57927 17.9893 5.84036 17.8496C6.10146 17.7099 6.31399 17.4973 6.73905 17.0723L14.287 9.52435C12.5376 8.43181 11.0588 6.96318 9.95553 5.23379Z",
    fill: "#5F6C8E"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPrior);
export default __webpack_public_path__ + "static/media/prior.8a3894a3f7f981ea9e62aad9f6c9cd3f.svg";
export { ForwardRef as ReactComponent };